import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preloader',
  templateUrl: './preloader.component.html',
})
export class PreloaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
